import React, { Fragment, useEffect, useMemo, useState } from 'react'
import { GetLocalStorage } from '../../commonClass/Session';
import { postUsersData } from '../../../services/ApiCallingUserServices';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import RichTextBox from '../../../customControl/RichTextBox';

function PrivacyPolicy({ sectionTab, userRights, setUpdateFetch, policyData }) {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [errorMessage, setErrorMessage] = useState({})
    const [privacypolicy, setPrivacyPolicy] = useState({
        Description: '',
        IsActive: true,
        PrivacyPolicyId: 0,
    });
    const [privacyRef, setPrivacyRef] = useState(null);
    const [richboxheight, setRichBoxHeight] = useState(false);
    const [disabled, setDisabled] = useState(false);
    const [editorKey, setEditorKey] = useState(0);

    useEffect(() => {
        setPrivacyPolicy(
            {
                ...privacypolicy,
                Description: policyData?.Description,
                PrivacyPolicyId: policyData?.PrivacyPolicyId
            }
        )
    }, [policyData?.Description])

    const isValidData = () => {
        let isValid = true;
        let ErrorMessa = {};


        if (privacypolicy?.Description?.trim()?.length <= 0) {
            ErrorMessa['privacypolicy'] = 'Can not leave blank, input is mandatory.'
            isValid = false
        }

        setErrorMessage(ErrorMessa)
        return isValid
    }

    const handleAddClick = async (data) => {

        if (isValidData(sectionTab)) {
            const userdata = GetLocalStorage()
            const URL = 'insertprivacypolicy'
            const updateAndSave = await postUsersData(`/master/v1/${URL}`, {
                ...data, IsActive: true,
                UserId: userdata?.userMasterID
            })

            if (updateAndSave.status) {
                setUpdateFetch(true)
                dispatch({ type: 'ALERTING', message: updateAndSave.message })
                setErrorMessage({})
            } else {
                dispatch({ type: 'ALERTING', message: updateAndSave.message })
            }
        }
    }

    const handleClearClick = () => {
        setPrivacyPolicy(prev => ({ ...prev, Description: "" }));
        if (privacyRef?.current) {
            privacyRef.current.value = ''; 
        }
        setErrorMessage({})
    }

    const handleDescriptionUpdate = (value) => {
        setPrivacyPolicy(prev => ({
            ...prev,
            Description: value
        }));
    }

    const answerconfig = useMemo(() => ({
        readonly: false,
        maxHeight: richboxheight === true ? 400 : 600,
        width: '100%',
        statusbar: false,
        disablePlugins: ["source"],
        removeButtons: ["about", "image", "link", "select", "video"],
        toolbarAdaptive: false,
        defaultMode: "1",
        disabled: disabled
    }), [disabled, richboxheight]);
    return (
        <Fragment>
            <div className="container-fluid mt-4 heading_color">
                <h3>Privacy Policy</h3>
            </div>

            <div className='row m-0'>
                <div className="col-lg-3 col-md-12 col-sm-12 mb-lg-1">
                    <label htmlFor="Answer" className="col-form-label required">Type something</label>
                </div>

                <div className=" col-lg-9 col-md-12 col-sm-12 mb-lg-1">
                    <RichTextBox
                        field={'PrivacyPolicy'}
                        fieldvalue={privacypolicy.Description}
                        tabIndex={2}
                        onBlur={handleDescriptionUpdate}
                        textconfig={answerconfig}
                        setRef={setPrivacyRef}
                    />

                    {errorMessage?.privacypolicy && <div className="text-start text-danger"> {errorMessage?.privacypolicy} </div>}
                </div>
            </div>

            <div className="d-flex justify-content-center mt-4">
                <button type="button" class="btn btn-primary mx-1" id="btnAdd"
                    onClick={() => handleAddClick(privacypolicy)}
                    disabled={!userRights?.URightAdd || !userRights?.URightEdit}
                >Add</button>
                {/* <button type="button" className="btn btn-primary mx-1" id="btnAdd" onClick={handleAddClick} disabled={editdisabled ? false : true}>{buttonaddeditText}</button>} */}
                <button type="button" className="btn btn-primary mx-1" id="btnClear"
                    onClick={() => handleClearClick()}
                >Clear</button>
            </div>
        </Fragment>
    )
}

export default PrivacyPolicy